module.exports = __webpack_public_path__ + "_assets/img/edit.9764d07c.svg";